module.exports = __webpack_public_path__ + "img/close.3a182a8.png";